import React, {Component, Fragment} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {has} from "lodash"

import ScheduledRecognitionsQuery from "@irati/recognition/apollo/query/ScheduledRecognitions"
import Loader from "@irati/utils/services/apollo/Loading/Loader"
import scrollAtBottom from "@irati/utils/scroll/scrollAtBottom"

import {AccountRecognitionList,} from "@irati/types"
import {TransitionFeed} from "../../../components/Feed"
import LoadMore from "../../../components/LoadMore"
import ScheduledRecognition from "../../../components/Polls/ClosedPoll/ScheduledRecognition"
import {StyledFeedItem} from "../../../components/Feed/styled/FeedItem"
import Empty from "./Empty"

const Feed = styled(TransitionFeed)`
  margin-bottom: ${({theme}) => theme.spacing.four};

  ${StyledFeedItem} {
    :hover {
      cursor: initial;
    }
  }
`

class ScheduledRecognitions extends Component {
  static propTypes = {
    recognitions: PropTypes.object.isRequired,
    handleClickCard: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      hasRefetchingError: false
    }
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll = () => {
    const atBottom = scrollAtBottom()
    const {hasRefetchingError} = this.state

    if (atBottom && !hasRefetchingError && this.fetchMore) {
      this.fetchMore()
    }
  }

  isEmpty(scheduledRecognitions: AccountRecognitionList) {
    return scheduledRecognitions?.results?.length === 0
  }

  fetchMore = () => {
    this.setState({
      hasRefetchingError: false
    })
    this.fetchMore().catch(() => {
      this.setState({
        hasRefetchingError: true
      })
    })
  }

  hasData = (data) => {
    return has(data, "scheduledRecognitions.results") && data.scheduledRecognitions.results.length > 0
  }

  returnVariables = (data, variables) => {
    return this.hasData(data) ? {...variables, cursor: data.scheduledRecognitions.cursor} : variables
  }

  render() {
    const {recognitions, handleClickCard} = this.props
    const {hasRefetchingError} = this.state

    return (
      <ScheduledRecognitionsQuery {...recognitions}>
        {({data, refetch, fetchMore, loading: isLoading, error, networkStatus}) => {
          const hasData = this.hasData(data)
          const hasError = error || hasRefetchingError
          const isRefetching = networkStatus === 3
          const variables = this.returnVariables(data, recognitions.variables)
          const hasMoreData = !!data?.scheduledRecognitions?.cursor && data?.scheduledRecognitions?.cursor !== "null"
          this.fetchMore = !isLoading && hasMoreData ? () => fetchMore(variables) : null

          return isLoading && !isRefetching ? (
            <Loader />
          ) : (
            <Fragment>
              {hasData && (
                <Feed
                  arr={data.scheduledRecognitions.results}
                  component={({onClick, item}) => {
                    return <ScheduledRecognition onClick={onClick} recognition={item} />
                  }}
                  onClick={handleClickCard}
                />
              )}
              {isLoading && <Loader />}
              {!isLoading && hasError && <LoadMore onClick={error ? () => refetch(variables) : this.fetchMore} />}
              {!isLoading && !hasError && !hasData && <Empty />}
            </Fragment>
          )
        }}
      </ScheduledRecognitionsQuery>
    )
  }
}

export default ScheduledRecognitions
